import { type OAuthClientInfo, OAuthClientInfoSchema, type OAuthCompleteResponse, OAuthCompleteResponseSchema } from "@storyline/shared";
import { env } from "@/src/common/constants/env";
import { requestJson } from "@/src/common/services/json-request.service";

export const completeOAuthAuthorization = async (query: string): Promise<OAuthCompleteResponse> =>
	OAuthCompleteResponseSchema.parse(await requestJson(`${env.SERVER_URL}/oauth/complete`, "POST", { query }));

export const fetchOAuthClientInfo = async (clientId: string): Promise<OAuthClientInfo> =>
	OAuthClientInfoSchema.parse(await requestJson(`${env.SERVER_URL}/oauth/client-info?clientId=${encodeURIComponent(clientId)}`, "GET"));
